import { useEffect, useState } from "react";
import builder from "../utils/builderWithLocale";

export function useGlobalSeo() {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    builder
          .get("seo")
          .then((data) => {
            setSeo(data);
          })
          .catch((error) => console.error("Error fetching content:", error));
  }, []);

  return seo;
}
